import React, {useEffect, useRef, useState} from "react";
import {Range, getTrackBackground, useThumbOverlap} from 'react-range';

import styles from './rangeInput.module.css'
import {useHistory, useLocation} from "react-router-dom";
import queryString from "query-string";

const ThumbLabel = ({rangeRef, values, index}) => {
    let [labelValue, style] = useThumbOverlap(rangeRef, values, index,1);

    if (style.left === '0px') {
        style = {}
        labelValue = values[index]
    }

    return (
        <div
            data-label={index}
            style={{
                ...style,
                display: 'block',
                position: 'absolute',
                top: '-22px',
                color: '#1D1D1B',
                fontWeight: '500',
                fontSize: '12px',
                fontFamily: `"Plus Jakarta Sans", sans-serif`,
                padding: '4px',
                whiteSpace: 'nowrap'
            }}
        >
            {labelValue}
        </div>
    );
};

function RangeInput({min, max, search, sync, range, rangeSelected}) {

    const history = useHistory()
    const location = useLocation()
    const queryParams = queryString.parse(location.search,{arrayFormat: 'comma'})
    const rangeRef = useRef()
    const [localMin , setLocalMin] = useState(min)
    const [localMax , setLocalMax] = useState(max)
    const [values, setValues] = useState([queryParams["min"] ? parseInt(queryParams["min"]) : min, queryParams["max"] ? parseInt(queryParams["max"]) : max])

    useEffect(() => {
        if (sync) {
            setLocalMin(min)
            setLocalMax(max)
            setValues([sync.min ? sync.min : min, sync.max ? sync.max : max])
        }
    },[sync, max ,min])

    useEffect(() => {
        if (range && rangeSelected) {
            setLocalMin(range.min)
            setLocalMax(range.max)
            setValues([parseInt(rangeSelected.min ? rangeSelected.min : range.min), parseInt(rangeSelected.max ? rangeSelected.max : range.max)])
        }
    },[range, rangeSelected])

    return (
        <Range
            ref={rangeRef}
            values={values}
            min={localMin}
            max={localMax}
            step={1}
            onChange={(values) => {setValues(values)}}
            onFinalChange={(finalValues) => {
                const params = [
                    {name: "min", value: finalValues[0], type: "string"},
                    {name: "max", value: finalValues[1], type: "string"},
                ]

                if (parseInt(queryParams.min) !== finalValues[0] || parseInt(queryParams.max) !== finalValues[1]) {
                    search(params, location, history, queryParams)
                }
            }}
            renderTrack={({ props, children }) => (
                <div
                    onMouseDown={props.onMouseDown}
                    onTouchStart={props.onTouchStart}
                    style={{...props.style}}
                    className={styles.wrapper}
                >
                    <div
                        ref={props.ref}
                        style={{
                            background: getTrackBackground({
                                values,
                                colors: ['#FFFFFF', '#720B0B', '#FFFFFF'],
                                min: localMin,
                                max: localMax,
                            })
                        }}
                        className={styles.track}
                    >
                        {children}
                    </div>
                </div>
            )}
            renderThumb={({ index, props }) => {
            const { key, ...restProps } = props; // Extract key from props

            return (
                <div {...restProps} key={key} style={restProps.style}>
                    <div className={styles.thumb}></div>
                    <ThumbLabel
                        rangeRef={rangeRef.current}
                        values={values}
                        index={index}
                    />
                </div>
            );
        }}
        />
    )
}

export default RangeInput